// This file contains domain URI values(reg expression) for MAERSK & SEALAND brands

export const domainUrlRegExp = {  
  MAERSK: /\Wmaersk.com\W/,
  SEALAND: /\Wsealandmaersk.com\W/,
  HAS: /\Whamburgsud\W/
};
